import { store } from 'store/store';
import React from 'react';
import { Provider } from 'react-redux';
import ReactWebComponent from 'react-web-component';
import App from './App';

const Wrapper = (props: any) => {
  return (
    <Provider store={store}>
      <App {...props} />
    </Provider>
  );
};

ReactWebComponent.create(<Wrapper />, 'graphic-novell');
